import React, { useState } from 'react';
import PropTypes from 'prop-types';

const BannerStickyImage = (props) => {
  const {
    imgClass,
    imgSrc,
    imgAlt,
    clickAction,
    imgWidth,
    imgHeight,
    animationLoading,
    bannerImageId,
  } = props?.image;

  const [isLoading, setIsLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const resetImageClicked = () => {
    setIsClicked(false);
  };

  const handlerOnClick = () => {
    const response = clickAction();
    setIsClicked(response);
    setTimeout(resetImageClicked, 1000);
  };

  return (
    <div id="BannerStickyImageId">
      {isLoading ? null : animationLoading}
      <img
        bannerimageclickedstate={`${isClicked}`}
        bannerimageid={`${bannerImageId}`}
        style={isLoading ? {} : { display: 'none' }}
        className={imgClass || ''}
        src={imgSrc || ''}
        alt={imgAlt || ''}
        onClick={handlerOnClick || ''}
        width={imgWidth || '100%'}
        height={imgHeight || '100%'}
        onLoad={() => setIsLoading(true)}
      />
    </div>
  );
};

BannerStickyImage.propTypes = {
  image: PropTypes.shape({
    imgClass: PropTypes.string,
    imgAlt: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    clickAction: PropTypes.func.isRequired,
    imgWidth: PropTypes.string,
    imgHeight: PropTypes.string,
    animationLoading: PropTypes.object,
    bannerImageId: PropTypes.string,
  }),
};

export default BannerStickyImage;
